import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmModal.vue?vue&type=style&index=0&id=6947106a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6947106a"]])

export default __exports__